const AuthBreederRegister = () =>
    import(
        /*webpackChunkName: "auth-breeder-register" */ "@/app/views/auth-view/components/auth-breeder-register/components/auth-breeder-register/auth-breeder-register.vue"
    );

export default {
    name: "AuthBreederRegisterContainer",
    components: {
        AuthBreederRegister,
    },
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    methods: {},
    // third party libraries
};
